module.exports = __webpack_public_path__ + "media/images/icons/clock-white-1c501caa779f4c72f3d62440547a90bf.svg";